import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie auth — never reads tokens from localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

const safeRemoveUser = () => {
  try {
    localStorage.removeItem("mukti_user");
  } catch {
    /* localStorage unavailable (private-mode); safe to ignore */
  }
};

const PUBLIC_PATHS = ["/login", "/splash", "/citizen"];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      safeRemoveUser();
      const path = window.location.pathname;
      const onPublic = PUBLIC_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
      if (!onPublic) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);
